// components/BranchGroup.tsx
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ParentGroup from "./ParentGroup";
import { groupByParentSubject } from "utils/schoolUtils"; 

type Props = {
  branchGroup: {
    branchId: string | null;
    branchName: string;
    items: any[];
  };
  onDelete: (id: string) => void;
};

const BranchGroup: React.FC<Props> = ({ branchGroup, onDelete }) => {
  const { t } = useTranslation();

  const parentGroups = useMemo(
    () => groupByParentSubject(branchGroup.items),
    [branchGroup.items]
  );

  const isBase = !branchGroup.branchId;
  const titleText = isBase ? t("base_subjects") : branchGroup.branchName;

  // Choose a simple icon class (Tabler Icons, matching your "ti ti-trash")
  const iconClass = isBase ? "ti ti-layers-subtract" : "ti ti-git-branch";

  return (
    <div key={branchGroup.branchId ?? "no_branch"} className="mb-4">
      {/* Header (icon + uppercase title + divider line) */}
      <div
        className="d-flex align-items-center my-2"
        style={{ borderBottom: "2px solid #e0e0e0", paddingBottom: 6 }}
      >
        {/* Icon (no color dot) */}
        <i
          className={`${iconClass}`}
          style={{
            fontSize: 18,
            marginRight: 10,
            color: "#666",
            lineHeight: 1,
          }}
          aria-hidden
        />

        {/* Title */}
        <span
          className="fw-bold text-uppercase"
          style={{ fontSize: "1rem", letterSpacing: "0.5px", color: "#333" }}
        >
          {titleText}
        </span>

        {/* Divider extension */}
        <div
          style={{
            flex: 1,
            height: 1,
            backgroundColor: "#e0e0e0",
            marginLeft: 12,
          }}
        />
      </div>

      {/* Parent buckets */}
      {parentGroups.map((pg: any) => (
        <ParentGroup key={pg.parentId} parentGroup={pg} onDelete={onDelete} />
      ))}
    </div>
  );
};

export default BranchGroup;
